import React from 'react';

import { flagStyles } from '../settings';

const SvgBF = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-456px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBF;
